var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pot-1-dispatcher',{attrs:{"is-dispatcher":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }